import React from 'react'
import { NumberInput, SelectInput, TextInput } from 'react-admin'
import { Skeleton } from '@mui/material'
import { DatePickers } from '../react-hook-fields'

export const Input = ({
  type,
  source,
  label,
  validate,
  onChange,
  isLoading,
  optionText,
  optionValue,
  inputProps,
  ...props
}) => {
  const choices = props.choices || []

  const getTextInput = () => (
    <TextInput source={source} label={label} validate={validate} fullWidth onChange={onChange} {...props} />
  )

  const getSelectInput = () => (
    <SelectInput
      source={source}
      optionText={optionText || 'long_name'}
      optionValue={optionValue || 'id'}
      label={label}
      fullWidth
      choices={choices}
      validate={validate}
      onChange={onChange}
      {...props}
    />
  )

  const hasInputProps = (inputProps) => {
    try {
      if (inputProps && inputProps?.maxLength) {
        return true
      }
      return false
    } catch (error) {
      return false
    }
  }

  const getNumberInput = () => {
    const parse = (value) => {
      if (value == null || value === '') {
        return null
      }
      const number = type === 'int' ? parseInt(value) : parseFloat(value)

      return isNaN(number) ? 0 : number
    }

    return (
      <NumberInput
        source={source}
        label={label}
        validate={validate}
        fullWidth
        onChange={onChange}
        min={0}
        parse={parse}
        inputProps={
          hasInputProps(inputProps) && {
            maxLength: inputProps?.maxLength,
            onInput: (e) => {
              if (e.target.value.length > inputProps?.maxLength) {
                e.target.value = e.target.value.slice(0, inputProps?.maxLength)
              }
            },
          }
        }
        {...props}
      />
    )
  }

  const getDatePicker = () => (
    <DatePickers
      source={source}
      label={label}
      validate={validate}
      onChange={onChange}
      viewsShow={false}
      {...props}
    />
  )

  return (
    <>
      {isLoading && <Skeleton variant='rectangular' width={'100%'} height={40} />}
      {type === 'str' && getTextInput()}
      {type === 'select' && props.choices && props.choices.length > 0 && getSelectInput()}
      {(type === 'int' || type === 'float') && getNumberInput()}
      {type === 'date' && getDatePicker()}
    </>
  )
}
